import React, { ReactNode } from 'react'
import styles from './IconTextView.module.css';

export interface IconTextViewProps {
    icon: ReactNode
    text: string
}

export default function IconTextView({ icon, text }: IconTextViewProps) {
    return (
        <div className={styles.content}>
            <div className={styles.icon}>
                {icon}
            </div>
            <div className={styles.text}>
                {text}
            </div>
        </div>
    )
}